NLMK.selectBoxRange = function () {
    const $selectMin = $('.js-select-box-min');
    const $selectMax = $('.js-select-box-max');

    $selectMin.on('change', function () {
        const $minSelect = $(this).find('select');

        const $maxSelect = $(this).closest('.col').siblings('.col').find('select');
        $maxSelect.find('option').each((i, item) => {
            if (parseInt($(item).text()) < parseInt($minSelect.val())) {
                $(item).attr('disabled', 'disabled');
            }
        });
        $maxSelect.trigger('change');
    });

    // $selectMax.on('change', function () {
    //     let maxValue = $(this).find('select').val();
    //     let minValue = $(this).closest('.col').siblings('.col').find('select').val();

    //     if (minValue >= maxValue) {
    //         minValue = maxValue;

    //         $(this).closest('.col').siblings('.col').find('select').val(minValue);
    //         $(this).closest('.col').siblings('.col').find('select').trigger('change');
    //     }
    // });
};

NLMK.selectBoxRange();



// WEBPACK FOOTER //
// ./js/main/module/select-box-range.js